<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div
    v-cloak
    class="d-flex  align-center justify-center flex-column"
    style="height: 100%;position: relative"
  >
    <div
      style="width: 70%;max-width: 420px;"
    >
      <loading-provider :loading="!loginStateReady">
        <template>
          <template v-if="useAutoLogin">
            <div
              v-if="!confirmOk"
              class="d-flex flex-column align-center justify-center"
            >
              <v-card
                class="py-12 mt-6 d-flex flex-column align-center"
                color="grey lighten-4"
                elevation="0"
                width="70%"
              >
                <v-progress-circular indeterminate />
              </v-card>
            </div>
            <div
              v-else
              class="d-flex flex-column align-center justify-center"
            >
              <v-card
                class="py-12 mt-6 d-flex flex-column align-center"
                color="grey lighten-4"
                elevation="0"
                width="70%"
              >
                <v-icon size="48">
                  mdi-check
                </v-icon>
                <div class="mt-4">
                  {{ $t('EmailValidationSuccessfully') }}
                </div>
                <v-btn
                  class="mt-4"
                  color="grey lighten-4 black--text"
                  elevation="0"
                  @click="closeTab"
                >
                  {{ $t('OK') }}
                </v-btn>
              </v-card>
            </div>
          </template>
          <template v-else-if="!sendFinish">
            <div class="d-flex">
              <v-spacer />
            </div>
            <template v-if="!usePasswordLogin">
              <div
                class="d-flex flex-column justify-center"
              >
                <div
                  class="text-h3 mb-4 font-weight-black hidden-sm-and-down"
                >
                  {{ $t('StartWithAaden') }}
                </div>
                <div class="text-body-1">
                  {{ $t('EnterEmailAddress') }}<br>
                  {{ $t('SentConformationMailToUrMailAccount') }}
                </div>
              </div>
              <div
                class="mt-8"
                style="min-height: 196px;"
              >
                <div>
                  <div class="text-body-2 mb-1">
                    {{ $t('emailAddress') }}
                  </div>
                  <v-text-field
                    v-model="email"
                    :validate-on-blur="false"
                    hide-details
                    name="email"
                    outlined
                    placeholder="youremail@email.com"
                    @keyup.enter="submit"
                  />
                </div>
                <div class="my-4 text-body-2 text--secondary">
                  {{ $t('PrivacyPolicyTTermsConditions') }}
                </div>
                <v-btn
                  :loading="loading"
                  block
                  class="text-h4"
                  color="amber lighten-4 black--text"
                  elevation="0"
                  height="48"
                  @click="submit"
                >
                  {{ $t('Login') }}
                </v-btn>
                <div
                  class="d-flex justify-center align-center mt-2"
                  @click="havePassword"
                >
                  <p class="underline-on-hover mt-4">
                    {{ $t('AlreadyHavePSWD') }}
                  </p>
                  <v-icon>
                    mdi-arrow-right-thin
                  </v-icon>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="!passwordForget">
                <div
                  class="d-flex flex-column justify-center"
                >
                  <div
                    class="text-h3 mb-4 font-weight-black hidden-sm-and-down"
                  >
                    {{ $t('StartWithAaden') }}
                  </div>
                  <div class="text-body-1">
                    {{ $t('EnterLoginCredentials') }}
                  </div>
                </div>
                <div
                  class="mt-8"
                  style="min-height: 196px;"
                >
                  <div>
                    <div class="text-body-2 mb-1">
                      {{ $t('emailAddress') }}
                    </div>
                    <v-text-field
                      v-model="email"
                      :validate-on-blur="false"
                      hide-details
                      name="email"
                      outlined
                      placeholder="youremail@email.com"
                    />
                  </div>
                  <div>
                    <div class="text-body-2 mb-1 mt-2">
                      {{ $t('password') }}
                    </div>
                    <v-text-field
                      v-model="password"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :error="error"
                      :error-messages="errorMessages"
                      :rules="[rules.required]"
                      :type="showPassword ? 'text' : 'password'"
                      name="password"
                      outlined
                      @change="resetErrors"
                      @keyup.enter="submit"
                      @click:append="showPassword = !showPassword"
                    />
                  </div>
                  <div class="mb-4 text-body-2 text--secondary">
                    {{ $t('PrivacyPolicyTTermsConditions') }}
                  </div>
                  <v-btn
                    :loading="loading"
                    block
                    class="text-h4"
                    color="amber lighten-4 black--text"
                    elevation="0"
                    height="48"
                    @click="submit"
                  >
                    {{ $t('Login') }}
                  </v-btn>
                  <v-btn
                    block
                    class="text-h5 mt-4"
                    elevation="0"
                    height="48"
                    outlined
                    @click="usePasswordLogin = false"
                  >
                    <v-icon class="mr-2">
                      mdi-email-outline
                    </v-icon>
                    {{ $t('OrUseMailLogin') }}
                  </v-btn>
                  <div
                    class="d-flex align-center justify-center align-center mt-2"
                    @click="passwordForget = true"
                  >
                    <p class="underline-on-hover mt-4">
                      {{ $t('PasswordReset') }}
                    </p>
                  </div>
                </div>
              </template>
              <template v-else>
                <v-card-title>{{ $t('PasswordResetTitle') }}</v-card-title>
                <v-card-text style="min-height: 196px">
                  <v-text-field
                    v-model="email"
                    :error="error"
                    :error-messages="resetPasswordMessage"
                    :label="$t('emailAddress')"
                    :rules="[rules.required]"
                    :validate-on-blur="false"
                    name="email"
                    outlined
                    @change="resetErrors"
                    @keyup.enter="submit"
                  />
                  <v-btn
                    :disabled="isSignInDisabled"
                    :loading="loading"
                    block
                    class="text-h4"
                    color="amber lighten-4 black--text"
                    elevation="0"
                    height="48"
                    @click="sendResetPasswordEmail"
                  >
                    {{ $t('PasswordResetToEmail') }}
                  </v-btn>
                  <v-btn
                    block
                    class="text-h4 mt-2"
                    color="blue lighten-4 black--text"
                    elevation="0"
                    height="48"
                    @click="passwordForget = false"
                  >
                    {{ $t('Zurück') }}
                  </v-btn>
                </v-card-text>
              </template>
            </template>
          </template>
          <template v-else>
            <div
              class="d-flex flex-column align-center justify-center text-center"
            >
              <div
                class="text-h4 font-weight-black"
              >
                {{ $t('ActivateAccountMailSentToFollowingMail', { mailAccount: email }) }}
              </div>

              <div class="text-body-1 mt-4 text--secondary">
                {{ $t('ActivateAccountOnEmailConfirmation') }}
              </div>

              <v-btn
                class="mt-4"
                color="grey lighten-4 black--text"
                elevation="0"
                @click="resetEmail"
              >
                {{ $t('ChangeActivationMail') }}
              </v-btn>
            </div>
          </template>
        </template>
        <template #loadingText>
          <div class="text-body-1">
            {{ $t('CheckAccountSettings') }}
          </div>
        </template>
      </loading-provider>

      <div
        class="d-flex flex-column align-center text-caption text--secondary"
        style="width: 100%;position: absolute;left: 0;right: 0;bottom: 48px;"
      >
        <div class="mb-4">
          <logo-display :with-version="true" />
        </div>
        <div>
          Copyright 2023, InnerKen All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  confirmLogin,
  createUserWithEmail,
  FireBaseAuth,
  listenForConfirm,
  loginWithAadenMetaId,
  loginWithEmailAndPassword,
  logInWithoutPassword,
  resetPasswordEmail,
  startSignInWithLink
} from '@/model/firebase/google-fire-base'

import LogoDisplay from '@/views/widget/uiComponent/LogoDisplay.vue'
import { Remember, requireOfflineMode } from '@/model/global/GlobalSettings'
import { useStoreOfflineMode } from '@/model/dataLayer/api/tableAndPerson/ServantManage'
import store from '@/model/global/store'
import { getCurrentUserId } from '@/model/dataLayer/api/SaaS/user'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import { isSignInWithEmailLink } from 'firebase/auth'
import IKUtils from 'innerken-js-utils'
import i18n from '@/i18n'

let id = ''
export default {
  name: 'LoginPage',
  components: {
    LoadingProvider,
    LogoDisplay
  },
  data () {
    return {
      resetPasswordMessage: '',
      version: require('../../../package.json').version,
      sendFinish: false,
      // sign in buttons
      loading: false,
      isSignInDisabled: false,
      email: '',
      password: '',
      error: false,
      errorMessages: '',
      useAutoLogin: false,
      confirmOk: false,
      // show password field
      showPassword: false,
      usePasswordLogin: true,
      rules: {
        required: (value) => (value && Boolean(value)) || i18n.t('required')
      },
      passwordForget: false
    }
  },
  computed: {
    ...mapState(['loginStateReady'])

  },
  async mounted () {
    if (requireOfflineMode()) {
      await this.offlineModeLogin()
    } else {
      await this.determinedNextStep()
    }

    setTimeout(async () => {
      if (!await getCurrentUserId()) {
        store.commit('loginStateReady')
      }
    }, 3000)
  },
  methods: {
    async sendResetPasswordEmail () {
      this.isSignInDisabled = true
      this.loading = true
      try {
        await resetPasswordEmail(this.email)
      } catch (e) {
        this.error = true
        this.loading = false
        this.resetPasswordMessage = this.$t('EnteredEmailIsNotRegisteredYet')
        this.isSignInDisabled = false
        return
      }
      this.loading = false
      this.isSignInDisabled = false
      this.passwordForget = false
      this.errorMessages = i18n.t('PasswordSuccessReset')
      this.password = ''
    },
    resetErrors () {
      this.error = false
      this.errorMessages = ''
    },
    havePassword () {
      this.loading = false
      this.usePasswordLogin = true
    },
    resetEmail () {
      this.email = ''
      this.sendFinish = false
      this.loading = false
      this.isSignInDisabled = false
    },
    closeTab () {
      window.close()
      loginWithAadenMetaId(id)
    },
    async loginBack () {
      this.useAutoLogin = true
      const aadenMetaId = IKUtils.getQueryString('aadenMetaId')
      id = aadenMetaId
      await confirmLogin(aadenMetaId)
      this.confirmOk = true
      setTimeout(() => {
        this.closeTab()
      }, 3000)

      console.log(aadenMetaId)
    },
    async determinedNextStep () {
      setTimeout(() => {
        this.email = Remember.lastLoginEmail
        if (isSignInWithEmailLink(FireBaseAuth, window.location.href)) {
          this.loginBack()
        }
      }, 50)
    },
    async offlineModeLogin () {
      await useStoreOfflineMode()
    },

    async submit () {
      if (this.email && !this.usePasswordLogin) {
        this.loading = true
        this.isSignInDisabled = true
        const res = await this.signIn(this.email)
        if (res) {
          this.loading = false
          this.sendFinish = true
          const unsub = listenForConfirm(res, (data) => {
            this.loading = true
            if (data.url) {
              logInWithoutPassword(this.email, data.url)
              this.loading = false
              unsub()
            }
            console.log('')
          })
        } else {
          this.loading = false
          this.isSignInDisabled = false
        }
        Remember.offlineMode = false
      }
      if (this.usePasswordLogin && this.email && this.password) {
        this.loading = true
        await this.signInWithPassword(this.email, this.password)
        this.loading = false
      }
    },
    async signIn (email) {
      try {
        return await startSignInWithLink(email)
      } catch (e) {
        this.error = true
        this.errorMessages = e.message
        return false
      }
    },
    async signInWithPassword (email, password) {
      try {
        await loginWithEmailAndPassword(email, password)
      } catch (e) {
        if (e.code === 'auth/user-not-found') {
          try {
            await createUserWithEmail(email, password)
          } catch (e) {
            this.error = true
            this.errorMessages = e.message
          }
        } else {
          console.log(e.code, 'login')
          this.error = true
          this.errorMessages = e.message
        }
      }
    }
  }
}
</script>

<style scoped>
.underline-on-hover:hover {
  text-decoration: underline;
}
</style>
